'use client';

import { createContext, useContext } from 'react';

type GlobalLayoutContextType = {
  correlationId: string;
};

const GlobalLayoutContext = createContext<GlobalLayoutContextType>({
  correlationId: ''
});

export function GlobalLayoutProvider({
  children,
  correlationId
}: {
  children: React.ReactNode;
  correlationId: string;
}) {
  return (
    <GlobalLayoutContext.Provider value={{ correlationId }}>
      {children}
    </GlobalLayoutContext.Provider>
  );
}

GlobalLayoutProvider.displayName = 'GlobalLayoutProvider';

export function useCorrelationId() {
  return useContext(GlobalLayoutContext).correlationId;
}
